import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPayByBank = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 63 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <mask
        id="PayByBank_svg__a"
        width={63}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M62.2 0H0v24h62.2z" />
      </mask>
      <g mask="url(#PayByBank_svg__a)">
        <mask
          id="PayByBank_svg__b"
          width={21}
          height={24}
          x={28}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <path
            fill="#fff"
            d="M32.421 1.292 44.631.018c2.093-.218 3.829 1.568 3.537 3.633L45.67 21.24c-.277 1.949-2.248 3.192-4.147 2.619l-11.605-3.511a2.405 2.405 0 0 1-1.695-2.634l2.048-14.363a2.425 2.425 0 0 1 2.15-2.06"
          />
        </mask>
        <g mask="url(#PayByBank_svg__b)">
          <mask
            id="PayByBank_svg__c"
            width={22}
            height={26}
            x={27}
            y={-1}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: "luminance",
            }}
          >
            <path
              fill="#fff"
              d="M30.532 1.383 48.808-.51l-3.666 25.435-17.175-5.2z"
            />
          </mask>
          <g mask="url(#PayByBank_svg__c)">
            <path
              fill="#400755"
              d="M48.808-.51 30.532 1.383l-2.56 18.342 17.17 5.205z"
            />
            <path
              fill="#CF002C"
              d="m38.759 14.367.937 2.942c.025.04.02.071.071.117.077.086.225.081.302-.046l1.96-2.75a.58.58 0 0 0 .067-.451l-1.203-3.395a.09.09 0 0 0-.081-.04c-.031 0-.062.03-.093.025l-1.868 2.77a.62.62 0 0 1-.63.315l-.025-.005a.8.8 0 0 1 .563.518"
            />
            <path
              fill="#DD3E56"
              d="M35.62 13.494c-.025-.005-.05.025-.081.05s-.031.057-.016.092l.932 3.166c.03.137.154.228.256.249l2.851.578c.174.036.302-.04.384-.198l.077-.122-.921-3.358c.025.03-3.481-.457-3.481-.457"
            />
            <path
              fill="#CF002C"
              d="m33.91 13.255-2.088-.289c-.02-.005-.061-.01-.066.02-.072.051-.134.183-.103.28l.737 2.699c.026.127.128.208.21.253l2.488.508c.046.01.082-.046.087-.076l.005-.03-.84-2.862a.98.98 0 0 1 .103-.726l.005-.03c-.143.157-.353.279-.537.253M37.208 8.552l1.638-2.588c.005-.03.036-.065.04-.096.021-.127-.046-.259-.179-.254l-2.575.03a.33.33 0 0 0-.296.189L34.14 8.638c-.026.03-.03.056-.01.092a.3.3 0 0 0 .061.06l2.427.122c.205.01.41.178.481.406l-.005.03a1.12 1.12 0 0 1 .113-.796"
            />
            <path
              fill="#DD3E56"
              d="M36.03 10.435q.046-.045.015-.092c.006-.03-.015-.066-.04-.066l-2.56-.197c-.113-.01-.215.07-.271.157l-1.516 2.532a.52.52 0 0 0-.061.426l.046.121 2.58.072.25-.427zM38.042 12.22q.021.036.077.041c.051.005.056-.025.087-.025l1.966-2.958a.56.56 0 0 0 .061-.432l-1.065-3.019c-.061-.126-.184-.223-.297-.223h-.133l-1.771 3.217.184.518z"
            />
          </g>
        </g>
        <path
          stroke="#ECECEF"
          strokeMiterlimit={10}
          strokeWidth={0.5}
          d="M44.654.267c1.934-.2 3.534 1.45 3.267 3.347l-2.497 17.592c-.253 1.795-2.071 2.944-3.827 2.414L29.99 20.108a2.15 2.15 0 0 1-1.536-2.164l.018-.196 2.05-14.367a2.165 2.165 0 0 1 1.923-1.84z"
        />
        <mask
          id="PayByBank_svg__d"
          width={21}
          height={24}
          x={14}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <path
            fill="#fff"
            d="M18.421 1.292 30.631.018c2.093-.218 3.829 1.568 3.537 3.633L31.67 21.24c-.277 1.949-2.248 3.192-4.147 2.619l-11.605-3.511a2.405 2.405 0 0 1-1.695-2.634l2.048-14.363a2.425 2.425 0 0 1 2.15-2.06"
          />
        </mask>
        <g mask="url(#PayByBank_svg__d)">
          <mask
            id="PayByBank_svg__e"
            width={22}
            height={26}
            x={13}
            y={-1}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: "luminance",
            }}
          >
            <path
              fill="#fff"
              d="M16.527 1.383 34.807-.51l-3.67 25.435-17.17-5.2z"
            />
          </mask>
          <g mask="url(#PayByBank_svg__e)">
            <path
              fill="#DB0011"
              d="M34.808-.51 16.527 1.383l-2.56 18.342 17.17 5.205z"
            />
            <path fill="#fff" d="m28.905 11.865-2.774-3.952-1.035 7.275z" />
            <path
              fill="#fff"
              d="m22.67 11.277 3.465-3.364-5.656-.168zM17.617 10.8l1.94 3.5.922-6.55z"
            />
            <path fill="#fff" d="M22.67 11.277 19.557 14.3l5.545.893z" />
          </g>
        </g>
        <path
          stroke="#ECECEF"
          strokeMiterlimit={10}
          strokeWidth={0.5}
          d="M30.654.267c1.934-.2 3.534 1.45 3.267 3.347l-2.497 17.592c-.253 1.795-2.071 2.944-3.827 2.414L15.99 20.108a2.15 2.15 0 0 1-1.536-2.164l.018-.196 2.05-14.367a2.165 2.165 0 0 1 1.923-1.84z"
        />
        <mask
          id="PayByBank_svg__f"
          width={21}
          height={24}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <path
            fill="#fff"
            d="M4.421 1.292 16.631.018c2.093-.218 3.829 1.568 3.537 3.633L17.67 21.24c-.277 1.949-2.248 3.192-4.147 2.619L1.918 20.343A2.405 2.405 0 0 1 .223 17.71L2.271 3.346a2.425 2.425 0 0 1 2.15-2.054"
          />
        </mask>
        <g mask="url(#PayByBank_svg__f)">
          <mask
            id="PayByBank_svg__g"
            width={22}
            height={26}
            x={-1}
            y={-1}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: "luminance",
            }}
          >
            <path
              fill="#fff"
              d="M2.527 1.383 20.807-.51l-3.67 25.435-17.17-5.2z"
            />
          </mask>
          <g mask="url(#PayByBank_svg__g)">
            <path
              fill="#00AFE9"
              d="M20.808-.51 2.527 1.383l-2.56 18.342 17.17 5.205z"
            />
            <path
              fill="#fff"
              d="M9.202 4.757c-.276.01-.338.071-.455.198h-.103c-.2.005-.501.04-.747.264-.246.188-.39.522-.297.73 0 0 .087-.121.358-.121h.123c.364.06.574.304.46.923-.112.619-.409 1.324-1.166 1.299 0 0-.098-.005-.185-.036-.348-.04-.399-.345-.399-.345s.318-.08.39-.563a.72.72 0 0 0-.436-.756 1.1 1.1 0 0 0-.338-.06c-.363 0-.798.202-1.131.67-.753 1.024-1.009 2.541-1.08 3.957-.072 1.42.435 2.851.445 2.912q.015.03.041.035t.026-.025c.337-.34.727-.822.89-1.167.118.137.005.452-.128.736s-.348.7-.414.842c-.082.107-.174.274-.077.38.02.006.02.036.04.036.134.02.497-.249.948-.822.522-.66.824-1.268.824-1.268.026.005.056.101.036.253-.026.183-.266.858-.66 1.446-.364.584-.697.924-.753 1.005-.03.056-.01.091.005.122.02.035.435.725 1.111 1.39.804.807 1.208 1.02 1.208 1.02s.446-.03 1.49-.462c.932-.375 1.633-.918 1.669-.98.03-.025.066-.055.046-.126-.041-.107-.287-.589-.543-1.334-.23-.731-.287-1.497-.281-1.695.025-.193.092-.254.123-.28 0 0 .143.747.527 1.569.348.76.69 1.192.86 1.217q.03.005.061-.025c.128-.081.067-.264.031-.436-.067-.147-.195-.675-.225-1.056-.031-.375-.072-.72.117-.832.113.421.374 1.07.717 1.568l.026.04s.036-.03.061-.025c.036-.03 1.183-1.466 1.643-3.166.466-1.715.63-3.52-.025-4.78-.287-.547-.789-.786-1.26-.786a1.8 1.8 0 0 0-.414.066c-.42.132-.717.457-.768.817-.077.523.276.634.276.634s-.153.295-.583.345c-.087.03-.17.026-.225.026-.303-.01-.553-.147-.743-.538-.158-.39-.05-1.157-.04-1.41.01-.254.066-.863-.139-1.081-.2-.249-.45-.305-.783-.325z"
            />
          </g>
        </g>
        <path
          stroke="#ECECEF"
          strokeMiterlimit={10}
          strokeWidth={0.5}
          d="M16.654.267c1.934-.2 3.534 1.45 3.267 3.347l-2.497 17.592c-.253 1.795-2.071 2.944-3.827 2.414L1.99 20.108a2.15 2.15 0 0 1-1.536-2.164l.018-.196 2.05-14.367a2.165 2.165 0 0 1 1.923-1.84z"
        />
        <path
          fill="#E2E2E6"
          d="M60.2 6h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2"
        />
        <path
          fill="#1F1F25"
          d="M52.2 12.752v-1.487h3.239V8h1.538v3.265H60.2v1.486h-3.223V16H55.44v-3.248z"
        />
      </g>
    </svg>
  );
};
export default SvgPayByBank;
